module.exports = __webpack_public_path__ + "static/media/utensils.e98eeacc.svg";